import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../common/ui/Logo';
import { MainContext } from '../../store/contexts';

export const AdminFooter = ({ user }) => {
    const { categories } = useContext(MainContext);

    const scrollTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <footer className="border-top py-5">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-4 text-center text-md-start mb-5">
                        <div className="text-muted">
                            <Link to="/" onClick={scrollTop}>
                                <Logo className="d-inline-block" color="muted" size="2x" />
                            </Link>
                            React Gift Shop © {new Date().getFullYear()}
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-2 text-center text-md-start mb-5">
                        <h5>User</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2">
                                <Link
                                    to="/admin"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Dashboard
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/user"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Profile
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/user/orders"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Orders
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-sm-6 col-md-2 text-center text-md-start mb-5">
                        <h5>Site</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2">
                                <Link
                                    to="/"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Home
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/admin/categories"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Categories
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/admin/products"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Products
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/admin/users"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Users
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/admin/orders"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Orders
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-sm-6 col-md-2 text-center text-md-start mb-5">
                        <h5>Gifts</h5>
                        <ul className="nav flex-column">
                            {(!categories.isLoading && !categories.error
                                ? categories.data.records
                                : []
                            ).map((category) => (
                                <li key={category.id} className="nav-item mb-2">
                                    <Link
                                        key={category.id}
                                        to={`/search?category=${category.name}`}
                                        onClick={scrollTop}
                                        className="nav-link p-0 text-muted">
                                        {category.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-sm-6 col-md-2 text-center text-md-start mb-5">
                        <h5>Errors</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2">
                                <Link
                                    to="/not-found"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Not Found
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/forbidden"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Forbidden
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/page-expired"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Page Expired
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/server-error"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Server Error
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/service-unavailable"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Service Unavailable
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/too-many-requests"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Too Many Requests
                                </Link>
                            </li>
                            <li className="nav-item mb-2">
                                <Link
                                    to="/unauthorized"
                                    onClick={scrollTop}
                                    className="nav-link p-0 text-muted">
                                    Unauthorized
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};
